const ListIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.6127 1.3125H2.2502C1.3877 1.3125 0.637695 2.025 0.637695 2.925V5.2875C0.637695 6.15 1.3502 6.9 2.2502 6.9H4.6127C5.4752 6.9 6.2252 6.1875 6.2252 5.2875V2.8875C6.1877 2.025 5.4752 1.3125 4.6127 1.3125ZM4.5002 5.175H2.3627V3H4.5002V5.175Z"
        fill="currentColor"
      />
      <path
        d="M9.63789 4.95001H22.5004C22.9504 4.95001 23.3629 4.57501 23.3629 4.08751C23.3629 3.60001 22.9879 3.22501 22.5004 3.22501H9.63789C9.18789 3.22501 8.77539 3.60001 8.77539 4.08751C8.77539 4.57501 9.18789 4.95001 9.63789 4.95001Z"
        fill="currentColor"
      />
      <path
        d="M4.6127 9H2.2502C1.3877 9 0.637695 9.7125 0.637695 10.6125V12.975C0.637695 13.8375 1.3502 14.5875 2.2502 14.5875H4.6127C5.4752 14.5875 6.2252 13.875 6.2252 12.975V10.6125C6.1877 9.7125 5.4752 9 4.6127 9ZM4.5002 12.8625H2.3627V10.6875H4.5002V12.8625Z"
        fill="currentColor"
      />
      <path
        d="M22.5004 10.95H9.63789C9.18789 10.95 8.77539 11.325 8.77539 11.8125C8.77539 12.3 9.15039 12.6375 9.63789 12.6375H22.5004C22.9504 12.6375 23.3629 12.2625 23.3629 11.8125C23.3629 11.3625 22.9504 10.95 22.5004 10.95Z"
        fill="currentColor"
      />
      <path
        d="M4.6127 17.1375H2.2502C1.3877 17.1375 0.637695 17.85 0.637695 18.75V21.1125C0.637695 21.975 1.3502 22.725 2.2502 22.725H4.6127C5.4752 22.725 6.2252 22.0125 6.2252 21.1125V18.75C6.1877 17.85 5.4752 17.1375 4.6127 17.1375ZM4.5002 21H2.3627V18.825H4.5002V21Z"
        fill="currentColor"
      />
      <path
        d="M22.5004 19.05H9.63789C9.18789 19.05 8.77539 19.425 8.77539 19.9125C8.77539 20.4 9.15039 20.775 9.63789 20.775H22.5004C22.9504 20.775 23.3629 20.4 23.3629 19.9125C23.3629 19.425 22.9504 19.05 22.5004 19.05Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ListSmallIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1762_2424)">
        <path
          d="M3.45977 0.984375H1.68789C1.04102 0.984375 0.478516 1.51875 0.478516 2.19375V3.96563C0.478516 4.6125 1.01289 5.175 1.68789 5.175H3.45977C4.10664 5.175 4.66914 4.64063 4.66914 3.96563V2.16562C4.64102 1.51875 4.10664 0.984375 3.45977 0.984375ZM3.37539 3.88125H1.77227V2.25H3.37539V3.88125Z"
          fill="currentColor"
        />
        <path
          d="M7.22891 3.71245H16.8758C17.2133 3.71245 17.5227 3.4312 17.5227 3.06558C17.5227 2.69995 17.2414 2.4187 16.8758 2.4187H7.22891C6.89141 2.4187 6.58203 2.69995 6.58203 3.06558C6.58203 3.4312 6.89141 3.71245 7.22891 3.71245Z"
          fill="currentColor"
        />
        <path
          d="M3.45977 6.75H1.68789C1.04102 6.75 0.478516 7.28437 0.478516 7.95937V9.73125C0.478516 10.3781 1.01289 10.9406 1.68789 10.9406H3.45977C4.10664 10.9406 4.66914 10.4062 4.66914 9.73125V7.95937C4.64102 7.28437 4.10664 6.75 3.45977 6.75ZM3.37539 9.64687H1.77227V8.01562H3.37539V9.64687Z"
          fill="currentColor"
        />
        <path
          d="M16.8758 8.2124H7.22891C6.89141 8.2124 6.58203 8.49365 6.58203 8.85928C6.58203 9.2249 6.86328 9.47803 7.22891 9.47803H16.8758C17.2133 9.47803 17.5227 9.19678 17.5227 8.85928C17.5227 8.52178 17.2133 8.2124 16.8758 8.2124Z"
          fill="currentColor"
        />
        <path
          d="M3.45977 12.853H1.68789C1.04102 12.853 0.478516 13.3874 0.478516 14.0624V15.8343C0.478516 16.4812 1.01289 17.0437 1.68789 17.0437H3.45977C4.10664 17.0437 4.66914 16.5093 4.66914 15.8343V14.0624C4.64102 13.3874 4.10664 12.853 3.45977 12.853ZM3.37539 15.7499H1.77227V14.1187H3.37539V15.7499Z"
          fill="currentColor"
        />
        <path
          d="M16.8758 14.2876H7.22891C6.89141 14.2876 6.58203 14.5688 6.58203 14.9345C6.58203 15.3001 6.86328 15.5813 7.22891 15.5813H16.8758C17.2133 15.5813 17.5227 15.3001 17.5227 14.9345C17.5227 14.5688 17.2133 14.2876 16.8758 14.2876Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1762_2424">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ListIcon;
